import { useEffect } from 'react';

const useTourmasterDatepicker = () => {
  useEffect(() => {
    const initializeDatepicker = () => {
      if (window.jQuery && window.jQuery.ui && window.jQuery.ui.datepicker) {
        const $ = window.jQuery;

        $('.tourmaster-custom-datepicker-wrap').each(function() {
          try {
            const dp_wrap = $(this);
            const dp_parent = dp_wrap.closest('.tourmaster-room-date-selection');
            const start_date_wrap = dp_wrap.siblings('.tourmaster-custom-start-date');
            const start_date_input = start_date_wrap.find('[name="start_date"]');
            const start_date_label = start_date_wrap.find('.tourmaster-tail');
            const end_date_wrap = dp_wrap.siblings('.tourmaster-custom-end-date');
            const end_date_input = end_date_wrap.find('[name="end_date"]');
            const end_date_label = end_date_wrap.find('.tourmaster-tail');

            let step = 1;
            const date_format = dp_wrap.attr('data-date-format') || 'd M yy';

            // Set initial dates
            let start_date = start_date_input.val() ? new Date(start_date_input.val() + 'T00:00:00') : new Date();
            let end_date = end_date_input.val() ? new Date(end_date_input.val() + 'T00:00:00') : new Date();
            end_date.setDate(start_date.getDate() + 1);

            const min_date = new Date();
            min_date.setHours(0, 0, 0, 0);
            const max_date = null;

            const dp_title = $(this).children('.tourmaster-custom-datepicker-title');
            
            const formatDate = (date, format) => {
              if ($.datepicker && $.datepicker.formatDate) {
                return $.datepicker.formatDate(format, date);
              }
              // Fallback formatting
              return date.toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
              });
            };

            let dp_val = {
              start_date: start_date.toISOString().split('T')[0],
              start_label: formatDate(start_date, date_format),
              end_date: end_date.toISOString().split('T')[0],
              end_label: formatDate(end_date, date_format)
            };

            function set_dp_title() {
              dp_title.html(dp_val.start_label + ' - ' + dp_val.end_label);
            }
            
            function close_dp() {
              dp_parent.removeClass('tourmaster-active');
              dp_wrap.fadeOut(150);
            }
            
            function set_dp_location() {
              dp_wrap.css({ 'right': '', 'left': '' });
              
              if (dp_parent.is('.tourmaster-vertical, .tourmaster-mobile')) {
                if (step === 1) {  // Changed from == to ===
                  dp_wrap.css('top', start_date_wrap.outerHeight());
                } else if (step === 2) {  // Changed from == to ===
                  dp_wrap.css('top', '');
                }
              } else {
                dp_wrap.css('top', '');
              }

              if (dp_wrap.offset().left + dp_wrap.outerWidth() > $(window).width()) {
                dp_wrap.css({ 'right': '0', 'left': 'auto' });
              }
            }

            // Initialize calendar
            const dp = dp_wrap.find('.tourmaster-custom-datepicker-calendar').datepicker({
              numberOfMonths: dp_parent.hasClass('tourmaster-horizontal') ? 2 : 1,
              stepMonths: 1,
              minDate: min_date,
              maxDate: max_date,
              defaultDate: start_date,
              changeMonth: true,
              changeYear: true,

              beforeShowDay: function(date) {
                // Removed unused tmp_date variable since it wasn't being used
                let selectable = true;

                if (step === 1) {
                  if (start_date && end_date) {
                    if (date.getTime() === start_date.getTime()) {
                      return [selectable, 'tourmaster-start', ''];
                    } else if (date.getTime() === end_date.getTime()) {
                      return [selectable, 'tourmaster-end', ''];
                    } else if (date.getTime() > start_date.getTime() && date.getTime() < end_date.getTime()) {
                      return [selectable, 'tourmaster-interval', ''];
                    }
                  }
                } else if (step === 2) {
                  if (date.getTime() < start_date.getTime()) {
                    return [false, '', ''];
                  } else if (date.getTime() === start_date.getTime()) {
                    return [false, 'tourmaster-start', ''];
                  } else if (date.getTime() === end_date.getTime()) {
                    return [selectable, 'tourmaster-end', ''];
                  } else if (date.getTime() > start_date.getTime() && date.getTime() < end_date.getTime()) {
                    return [selectable, 'tourmaster-interval', ''];
                  }
                }
                
                return [selectable, '', ''];
              },

              onSelect: function(dateText, inst) {
                const selected_date = inst.selectedYear + '-' + 
                  ('0' + (inst.selectedMonth + 1)).slice(-2) + '-' + 
                  ('0' + inst.selectedDay).slice(-2);

                if (step === 1) {
                  start_date = new Date(selected_date + 'T00:00:00');
                  dp_val.start_date = selected_date;
                  dp_val.start_label = formatDate(start_date, date_format);
                  start_date_input.val(dp_val.start_date);
                  start_date_label.html(dp_val.start_label);

                  end_date = new Date(start_date.getTime() + 86400000);
                  dp_val.end_date = end_date.toISOString().split('T')[0];
                  dp_val.end_label = formatDate(end_date, date_format);
                  end_date_input.val(dp_val.end_date);
                  end_date_label.html(dp_val.end_label);

                  step = 2;
                  set_dp_location();
                } else if (step === 2) {
                  end_date = new Date(selected_date + 'T00:00:00');
                  dp_val.end_date = selected_date;
                  dp_val.end_label = formatDate(end_date, date_format);
                  end_date_input.val(dp_val.end_date);
                  end_date_label.html(dp_val.end_label);
                  
                  step = 1;

                  if (dp_parent.is('.tourmaster-vertical, .tourmaster-mobile')) {
                    close_dp();
                  }
                }

                dp_parent.addClass('tourmaster-selected');
                dp_parent.attr('data-step', step);
                set_dp_title();
              }
            });

            set_dp_title();

            // Event handlers
            dp_wrap.siblings('.tourmaster-custom-start-date').on('click', function() {
              step = 1;
              dp_parent.addClass('tourmaster-active');
              dp_wrap.fadeIn(150);
              dp_parent.attr('data-step', step);
              set_dp_location();
              dp.datepicker('refresh');
            });

            dp_wrap.siblings('.tourmaster-custom-end-date').on('click', function() {
              step = 2;
              dp_parent.addClass('tourmaster-active');
              dp_wrap.fadeIn(150);
              dp_parent.attr('data-step', step);
              set_dp_location();
              dp.datepicker('refresh');
            });

            dp_wrap.on('click', '.tourmaster-custom-datepicker-close', function() {
              close_dp();
            });

            $(document).on('click', function(e) {
              if (!dp_parent.hasClass('tourmaster-active')) return;
              if ($(e.target).is('.ui-datepicker-prev, .ui-datepicker-next')) return;
              if (!$(e.target).closest('.tourmaster-custom-start-date, .tourmaster-custom-end-date, .tourmaster-custom-datepicker-wrap').length) {
                close_dp();
              }
            });

            // Handle window resize
            $(window).on('load resize', function() {
              if (dp_parent.hasClass('tourmaster-horizontal')) {
                const isMobile = window.matchMedia('(max-width: 768px)').matches;
                if (isMobile) {
                  if (!dp_parent.hasClass('tourmaster-mobile')) {
                    dp_parent.addClass('tourmaster-mobile');
                    dp.datepicker('option', 'numberOfMonths', 1);
                  }
                } else {
                  if (dp_parent.hasClass('tourmaster-mobile')) {
                    dp_parent.removeClass('tourmaster-mobile');
                    dp.datepicker('option', 'numberOfMonths', dp_parent.hasClass('tourmaster-horizontal') ? 2 : 1);
                  }
                }
              }
            });

          } catch (error) {
            console.error('Datepicker initialization error:', error);
          }
        });
      } else {
        setTimeout(initializeDatepicker, 100);
      }
    };

    initializeDatepicker();

    return () => {
      if (window.jQuery) {
        const $ = window.jQuery;
        $(document).off('click', '.tourmaster-custom-datepicker-close');
        $(window).off('load resize');
        $('.tourmaster-custom-datepicker-calendar').datepicker('destroy');
      }
    };
  }, []);
};

export default useTourmasterDatepicker;